import clsx from 'clsx';

import { Link } from '@/i18n/navigation';

import styles from '@/components/Breadcrumbs/Breadcrumbs.module.scss';
import { TruncatedText } from '@/components/TruncatedText';

interface BreadcrumbsProps {
  links: { href: string; label: string }[];
  containerClassName?: string;
}

export const Breadcrumbs = (props: BreadcrumbsProps) => {
  const { links } = props;

  const classNames = clsx(styles.breadcrumbs, props.containerClassName);

  return (
    <div className={classNames}>
      <ul className={styles.breadcrumbsList}>
        {links.map((link, index) => {
          const isLast = index === links.length - 1;
          return (
            <li key={index} className={styles.breadcrumbsItem}>
              {!isLast ? (
                <Link className={styles.breadcrumbsLink} href={link.href}>
                  {link.label}
                </Link>
              ) : (
                <TruncatedText lines={1} className={styles.breadcrumbsLink}>
                  {link.label}
                </TruncatedText>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};
